<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Aggiungi prodotto a magazzino temporaneo</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <!-- <component :is="'pProdotto'" :item="itemCodice" :suTable="true" @change="componentValueChange"/> -->
              <component :is="'pProdotto'" :item="itemCodice(editedItem, trigger)" :index="0" @change="componentValueChange" :updateTrigger="updateTrigger" :solo="false" :suTable="true" :isLotto="true" :isProdottoBase="true" :clearInfo="clearInfo" :popolaInfo="popolaInfo"/>
              <!-- <v-text-field v-model="prodotto" label="Prodotto"></v-text-field> -->
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field v-model="editedItem.descrizione" label="Descrizione"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="editedItem.lotto"
                :items="lottiProdotto"
                label="Lotti prodotto"
                item-text="testo"
                item-value="id"
                clearable
                dense
                hide-details="auto"
                :flat="true"
                :return-object="true"
                @change="onChange"
                @click:clear="editedItem.lotto=''"                
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.testo }}</span>
                </template>  
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <!-- <v-text-field v-model="quantita" label="Quantità"></v-text-field> -->
              <v-text-field v-model="editedItem.quantita" label="Quantità" flat dense :rules="[numerico]" reverse></v-text-field>
            </v-col>
            <v-col class="mt-2 font-weight-bold">{{ editedItem.unitaMisura }}</v-col>         
          </v-row>
          <v-row v-if="registraCaloPeso">
            <v-col cols="12" sm="12" md="6">
              <v-text-field v-model="nuovoPeso" label="Nuovo Peso"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-btn @click="onRegistraCaloPeso">Registra calo peso</v-btn>
            </v-col>            
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onAnnullaProdotto">Annulla</v-btn>
        <v-btn color="blue darken-1" text @click="onSalvaProdotto">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import pProdotto from '../../elementi/prodotto.vue'
  import { ordinaLotti } from '@/components/helpers'
  import prodotti from '@/services/prodottiService.js'

  export default {
    components: {
      pProdotto
    },
    props: {
      showDialog: Boolean,
      prodotto: Object,
      trigger: Number
    },
    data () {
      return {
        dialog: false,
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        nuovoPeso: '',
        registraCaloPeso: false,
        lottiProdotto: [],
        popolaInfo: 1,
        clearInfo: 1,
        updateTrigger: 1,
        editedItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 1,
          livello: 0
        },
        editedItemDefault: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 1,
          livello: 0
        }        
      }
    },
    watch: {
      showDialog(value) {
        if (value) {
          this.dialog = true
        }
      },
      trigger() {
        this.updateTrigger++
      },
      async prodotto(value) {
        console.log('change', value)
        Object.assign(this.editedItem, value)
        const dbProd = await prodotti.getProdotto(value.id)
        const magazzino = _.get(dbProd, 'magazzino') || {}
        this.registraCaloPeso = magazzino.caloPeso || false
        this.nuovoPeso = ''
        await this.popolaLottiProdotto(value.codice)
        this.editedItem.lotto = value.lotto
        const lotto = this.lottiProdotto.find(x => x.id === value.lotto)
        if (lotto) {
          this.editedItem.quantita = +parseFloat(lotto.giacenza).toFixed(3)  
        }
      }
    },
    methods: {
      onChange(value) {
        this.editedItem.quantita = +parseFloat(value.giacenza).toFixed(3)        
      },
      onAnnullaProdotto() {
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.editedItemDefault)))
        this.lottiProdotto = []
        this.registraCaloPeso = false
        this.nuovoPeso = ''
        this.clearInfo++
        this.dialog = false
      },
      onSalvaProdotto() {
        this.$emit('salvaProdotto', this.editedItem)
        this.onAnnullaProdotto()
      },
      itemCodice(item, trigger) {
        return {
          "model": "codice",
          "valueField": "codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (trigger && item && item.codice) || ''
        }
      },      
      async componentValueChange(data) {
        if (!data.value) {
          Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.editedItemDefault)))
          this.lottiProdotto = []
          this.registraCaloPeso = false
          this.nuovoPeso = ''
          return
        }
        const magazzino = _.get(data, 'item.item.magazzino') || {}
        // const giacenza = magazzino.giacenza || 0 // Nei temporanei carico solo i prodotti gestiti a lotto, gli altri vengono presi direttamente dal magazzino
        // this.editedItem.quantita = giacenza
        this.editedItem.codice = data.item.codice
        this.registraCaloPeso = magazzino.caloPeso || false
        await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        switch (data.model) {
          case 'codice':
            this.editedItem.descrizione = _.get(data, 'item.descrizione', '')
            this.editedItem.unitaMisura = _.get(data, 'item.item.magazzino.unitaMisura', '')
            this.updateTrigger++
            await this.popolaLottiProdotto(data.value)
            // this.elaboraDistinta()
            break
          default:
            break
        }
      },
      async popolaLottiProdotto(codiceProdotto, quantita) {
        const filtri = {
          codice: codiceProdotto,
          isLotto: true,
          isLottoBase: false
        }
        const opzioni =  {
          itemsPerPage: -1
        }
        const data = await prodotti.getFilteredProducts(filtri, opzioni)
        const cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
        //TODO: I lotti vanno ordinati secondo la gestione che è stata impostata (FIFO, FEFO, etc.)
        const gestione = _.get(this.item,'appoggio.prodotto.item.lotti.gestione.criterioConsumoScarico.codice', '')
        this.lottiProdotto = ordinaLotti(cp, gestione, quantita).map(x => {
          return {
            id: x.lotti.lotto,
            testo: x.lotti.lotto,
            testo: `${x.lotti.lotto} - sc:${x.lotti.scadenza || '---'} - qta:${x.magazzino.giacenza}`,
            codiceProdotto: x._id,
            giacenza: x.magazzino.giacenza, // TODO: Verificare per giacenza multipla
            scadenza: x.lotti.scadenza || '---' // TODO: Più eventuali altre date
          }
        })
      },
      onRegistraCaloPeso() {
        if (this.nuovoPeso) {
          // TODO: Fare movimento di rettifica quantità
          const delta = parseFloat(this.editedItem.quantita) - parseFloat(this.nuovoPeso)
          this.editedItem.quantita = +parseFloat(this.nuovoPeso).toFixed(3)
          this.$emit('registraCaloPeso', this.editedItem, delta)
        }
      }
    }
  }
</script>
